import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DocumentItemsListQueryEntity, DocumentItemEntity } from '../../../meta-data/app-meta-data.service';
import { DocumentCardData, DocumentCardType } from '../models/document-card-data.model';
import { DwOrmData } from '@devwareapps/devware-cap';
import { DocumentDataUpdateInfo } from '../models/docuemnt-data-update-info.model';
import { DocumentSheetComponent } from '../components/archive/document-sheet.component/document-sheet.component';
import { DocumentEditComponent } from '../components/edit-panels/document-edit/document-edit.component';
import { FolderEditComponent } from '../components/edit-panels/folder-edit/folder-edit.component';

@Injectable({
  providedIn: 'root'
})
export class DocumentSheetService {
  private isSheetOpenSubject = new BehaviorSubject<boolean>(false);
  private selectedDocumentSubject = new BehaviorSubject<DocumentCardData | null>(null);

  private documentDataUpdated = new Subject<DocumentDataUpdateInfo>();

  public isSheetOpen$: Observable<boolean> = this.isSheetOpenSubject.asObservable();
  public selectedDocument$: Observable<DocumentCardData | null> = this.selectedDocumentSubject.asObservable();
  public documentDataUpdated$: Observable<DocumentDataUpdateInfo> = this.documentDataUpdated.asObservable();

  constructor() { }

  openSheet(document: DocumentCardData): void {
    this.selectedDocumentSubject.next(document);
    this.isSheetOpenSubject.next(true);
  }

  closeSheet(): void {
    this.isSheetOpenSubject.next(false);
    // Optionally clear the document when closing, or keep it for reopening
    // this.selectedDocumentSubject.next(null);
  }

  getCurrentDocument(): DocumentCardData | null {
    return this.selectedDocumentSubject.value;
  }

  getIsSheetOpen(): boolean {
    return this.isSheetOpenSubject.value;
  } 

  notifyDocumentDataUpdated(data: DocumentDataUpdateInfo): void {
    this.documentDataUpdated.next(data);
  }


  getDocumentEditComponent(documentCard: DocumentCardData): Type<any> {
    switch (documentCard?.documentCardType) {
      case DocumentCardType.documentItem:
        return DocumentEditComponent;
      case DocumentCardType.folder:
        return FolderEditComponent;
    }

    return null; // no component for unknown type
  }
}
